import React from "react";
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandMore } from "@material-ui/icons";

import { SiteCommissioningSummary } from "../../../../dtos/siteCommissioning";
import { tokens } from "./console/tokens";
import { buildHardwarePreview } from "./hardwareConfigurationSummary";
import { HardwareConfigurationSummaryFields } from "./HardwareConfigurationSummaryFields";

const useStyles = makeStyles(() => ({
    panel: {
        boxShadow: "none",
        border: `1px solid ${tokens.line}`,
        borderRadius: "12px",
        "&:before": {
            display: "none",
        },
    },
    summaryText: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
        flexWrap: "wrap",
    },
    details: {
        flexDirection: "column",
        paddingTop: 0,
    },
}));

interface Props {
    summary?: SiteCommissioningSummary;
    title?: string;
    defaultExpanded?: boolean;
}

export const HardwareConfigurationSummaryPanel: React.FC<Props> = ({
    summary,
    title = "Hardware",
    defaultExpanded = false,
}) => {
    const classes = useStyles();
    const preview = buildHardwarePreview(summary);

    return (
        <ExpansionPanel className={classes.panel} defaultExpanded={defaultExpanded}>
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                <div className={classes.summaryText}>
                    <Typography variant="body2" style={{ fontWeight: 600 }}>{title}</Typography>
                    <Typography variant="body2" color="textSecondary">{preview}</Typography>
                </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.details}>
                <HardwareConfigurationSummaryFields summary={summary} />
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
};
